<div class="option-box" *ngIf="showBuzzerInfo()">
    <div class="p-3 section-title mb-4 pl-4 position-relative font-medium font-size-heading theme-light"
        id="buzzerInfo">
        {{'public.checkout.buzzerInformation' | translate}}
    </div>

    <div class="expandable-content-wrapper">
        <form class="mx-3" [formGroup]="buzzerInfoForm">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-group mx-2">
                        <app-input-text class="mb-4" inputId="buzzerNumber" maxLength="5" [inputType]="'number'"
                            [label]="'public.checkout.buzzerNumber' | translate" [required]="isRequired()"
                            [control]="getControl('buzzerNumber')"
                            [isInvalid]="checkoutService.isInvalid(getControl('buzzerNumber'))" [errorText]="
                getControl('buzzerNumber')?.errors?.required ? ('public.checkout.errors.fieldRequired' | translate) : ''
              " (changeEvent)="addOrderMeta('buzzerNumber', 'buzzerNumber')" appPreventEnter />
                    </div>
                </div>
            </div>
        </form>
    </div>

    <div class="form-group row ml-4" *ngIf="auth.isUserLoggedIn()">
        <div class="loading-screen d-flex justify-content-center align-items-center w-100"
            *ngIf=" customerDetailsChanged() && customerDetailsUpdateStatus === 'LOADING'">
            <div class="d-flex flex-column text-center">
                <div class="lds-ripple mx-auto">
                    <div></div>
                    <div></div>
                </div>
                <div class="loading-message">{{'public.load.loadingMessage' | translate}}</div>
            </div>
        </div>
        <div class="font-size-secondary" *ngIf=" customerDetailsChanged() && customerDetailsUpdateStatus !== 'LOADING'">
            <label class="custom-checkbox-label">
                <input class="checkbox" type="checkbox" (throttledClick)="updateCustomerDetails()" appPreventDoubleClick
                    [throttleTime]="3000" />
                <span> {{'public.checkout.saveCustomerDetailsForFuture' | translate}}</span>
            </label>
        </div>
        <div class="input-group valid-feedback font-size-secondary" *ngIf="customerDetailsUpdateStatus === 'SUCCESS'">
            <span> {{'public.checkout.customerDetailsUpdateSuccess' | translate}}</span>
        </div>
        <div class="input-group invalid-feedback font-size-secondary" *ngIf="customerDetailsUpdateStatus === 'FAILED'">
            <span> {{'public.checkout.errors.customerDetailsUpdateFailed' | translate}}</span>
        </div>
    </div>
</div>